import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import { TitleWorkspaceResponse } from 'types/api-responses';
import {
  agentPanelOpenAtomFamily,
  agentPanelWidthAtomFamily,
} from 'atoms/agent-chat-atoms';
import { TITLE_WORKSPACE_AGENT_TYPE } from 'components/agent-chat/agent-types';

export const useTitleWorkspaceAtom = (titleWorkspaceHref: string) =>
  useMemo(
    () => createResourceAtom<TitleWorkspaceResponse>(titleWorkspaceHref),
    [titleWorkspaceHref]
  );

export type TitleWorkspaceAtomType = ReturnType<typeof useTitleWorkspaceAtom>;

// Dock state for this page's agent panel. The geometry constants and the atom
// families now live in atoms/agent-chat-atoms so every page's dock shares one
// mechanism; these aliases keep the page's own call sites readable.
export const agentOpenAtom = agentPanelOpenAtomFamily(
  TITLE_WORKSPACE_AGENT_TYPE
);
export const agentWidthAtom = agentPanelWidthAtomFamily(
  TITLE_WORKSPACE_AGENT_TYPE
);
